import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PageLoader from "@/components/PageLoader";

export function Protected({ children, role }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) return <PageLoader label="Loading…" testid="protected-loader" />;
  if (!user) {
    const next = loc.pathname + loc.search + loc.hash;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  }
  return children;
}
